export default __webpack_public_path__ + "static/media/free-2-months.75e72042.svg";